import { LogLevel } from "@azure/msal-browser";

export const msalConfig = {
    auth: {
        clientId: "3ba6c4af-c2f4-48cb-941b-5deb27ec94e0",
        authority: "https://login.microsoftonline.com/17bba2ca-6c02-4fee-a63a-9c8ec709bf04",
        redirectUri: window.location.origin,
        postLogoutRedirectUri: window.location.origin,
    },
    cache: {
        cacheLocation: "localStorage", 
        storeAuthStateInCookie: true,
    },
    system: {
        allowPlatformBroker: false, // Disables WAM Broker
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                    default:
                        return;
                }
            },
        },
    },
};

// Scopes you need for the access token
export const loginRequest = {
    scopes: ["User.Read"]
};